<template>
  <div>
    <div class="flexBC">
      <el-card style="width: 32%; height: 400px">
        <div style="width: 100%; height: 400px" id="pie1"></div>
      </el-card>
      <el-card style="width: 32%; height: 400px">
        <div style="width: 100%; height: 400px" id="pie2"></div>
      </el-card>
      <el-card style="width: 32%; height: 400px">
        <div style="width: 100%; height: 400px" id="pie3"></div>
      </el-card>
    </div>
    <el-card class="mt20">
      <el-date-picker
        class="float_right"
        v-if="value === 'month'"
        v-model="value1"
        type="month"
        placeholder="select month"
      >
      </el-date-picker>
      <el-date-picker
        class="float_right"
        v-if="value === 'year'"
        v-model="value1"
        type="year"
        placeholder="select year"
      >
      </el-date-picker>
      <el-select class="float_right mr10" v-model="value" placeholder="select">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div style="width: 100%; height: 400px; margin-top: 40px" id="line"></div>
    </el-card>
    <el-card class="mt20">
      <el-select class="float_right mr10" v-model="visitValue" placeholder="select">
        <el-option
          v-for="item in visitRecordOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div style="width: 100%; height: 400px; margin-top: 40px" id="line1"></div>
    </el-card>
    <el-card class="mt20">
      <el-select class="float_right mr10" v-model="visitValue1" placeholder="select">
        <el-option
          v-for="item in visitRecordOptions1"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select class="float_right mr10" v-model="visitBook1" placeholder="select">
        <el-option
          v-for="item in bookList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div style="width: 100%; height: 400px; margin-top: 40px" id="line2"></div>
    </el-card>
  </div>
</template>
<script>
import { getStatistics, postStatistics, visitRecord, allBook } from "@/api/api";
import * as echarts from "echarts";
let myChart
let myChart1
let myChart2
let myChart3
let myChart4
let myChart5
export default {
  data() {
    return {
      allData:{},
      bookList:[],
      options: [
        { label: "", value: "all" },
        { label: "year", value: "year" },
        { label: "month", value: "month" },
      ],
      value: "month",
      value1: new Date(),

      visitRecordData:{},
      visitRecordOptions:[
        { label: "month", value: "month" },
        { label: "week", value: "week" },
        { label: "day", value: "day" },
      ],
      visitValue:'day',
      visitRecordData1:{},
      visitRecordOptions1:[
        { label: "month", value: "month" },
        { label: "week", value: "week" },
        { label: "day", value: "day" },
      ],
      visitValue1:'day',
      visitBook1:'전체',
      option: {
        title: {
          text: "회원",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ['신규회원','탈퇴회원'],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "신규회원",
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "탈퇴회원",
            type: "line",
            smooth: true,
            data: [],
          }
        ],
      },
      option1: {
        title: {
          text: "이벤트",
          left: "right",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ['모집 대기', '모집중', '마감 임박', '모집 마감'],
        },
        series: [
          {
            name: "from",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: 0, name: '모집 대기' },
              { value: 0, name: '모집중' },
              { value: 0, name: '마감 임박' },
              { value: 0, name: '모집 마감' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      option2: {
        title: {
          text: "매일연재",
          left: "right",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ['연재중', '완결'],
        },
        series: [
          {
            name: "from",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: 0, name: '연재중' },
              { value: 0, name: '완결' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      option3: {
        title: {
          text: "독서모임",
          left: "right",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ['모집중', '진행중', '진행완료', '모집대기', '진행대기'],
        },
        series: [
          {
            name: "from",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: 0, name: '모집중' },
              { value: 0, name: '진행중' },
              { value: 0, name: '진행완료' },
              { value: 0, name: '모집대기' },
              { value: 0, name: '진행대기' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      option4: {
        title: {
          text: "사이트 방문자 수",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ['사이트 방문자 수'],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "사이트 방문자 수",
            type: "line",
            smooth: true,
            data: [],
          }
        ],
      },
      option5: {
        title: {
          text: "연재 작품 조회수",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ['연재 작품 조회수'],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "연재 작품 조회수",
            type: "line",
            smooth: true,
            data: [],
          }
        ],
      },
    };
  },
  watch: {
    value() {
      this.value1 = new Date();
    },
    value1() {
      this.postStatistics(this.value === 'all'?'':this.value1.getFullYear(),this.value === 'month'?this.value1.getMonth()+1:'')
    },
    async visitBook1(){
      if(this.visitBook1 === ''){
        const res = await visitRecord({type:1})
        this.visitRecordData1 = res
        this.changeOtherLine()
      }else{
        const res = await visitRecord({book:this.visitBook1})
        this.visitRecordData1 = res
        this.changeOtherLine()
      }
    },
    visitValue() {
      this.changeOtherLine()
    },
    visitValue1() {
      this.changeOtherLine()
    },
  },
  methods: {
    changeLine() {
      var disable=[]
      var res=[]
      var name=[]
      this.allData.user_day_disable.forEach(item=>{
        disable.push(item.count)
        name.push(this.value === 'all'?item.year:this.value === 'year'?item.year+'-'+item.month:item.year+'-'+item.month+'-'+item.day)
      })
      this.allData.user_day_res.forEach(item=>{
        res.push(item.count)
      })
      this.option.xAxis.data = name
      this.option.series[0].data = res
      this.option.series[1].data = disable
      this.option.title.text = `회원(신규회원:${eval(res.join("+"))} 탈퇴회원:${eval(disable.join("+"))})`
      let myChart = echarts.getInstanceByDom(document.getElementById('line'))
      if(myChart == null){
        myChart = echarts.init(document.getElementById("line"));
      }
      myChart.resize()
      myChart.setOption(this.option);
    },
    changePie() {
      let sum1 = 0
      let sum2 = 0
      let sum3 = 0
      Object.values(this.allData.activity_status).forEach((item,index) => {
        this.option1.series[0].data[index].value = item
        sum1+=item
      })
      Object.values(this.allData.book_status).forEach((item,index) => {
        this.option2.series[0].data[index].value = item
        sum2+=item
      })
      Object.values(this.allData.club_status).forEach((item,index) => {
        this.option3.series[0].data[index].value = item
        sum3+=item
      })
      myChart1 = echarts.getInstanceByDom(document.getElementById('pie1'))
      if(myChart1 == null){
        myChart1 = echarts.init(document.getElementById("pie1"));
      }
      myChart2 = echarts.getInstanceByDom(document.getElementById('pie2'))
      if(myChart2 == null){
        myChart2 = echarts.init(document.getElementById("pie2"));
      }
      myChart3 = echarts.getInstanceByDom(document.getElementById('pie3'))
      if(myChart3 == null){
        myChart3 = echarts.init(document.getElementById("pie3"));
      }
      myChart1.resize()
      myChart2.resize()
      myChart3.resize()
      this.option1.title.text = `이벤트(${sum1})`
      this.option2.title.text = `매일연재(${sum2})`
      this.option3.title.text = `독서모임(${sum3})`
      myChart1.setOption(this.option1);
      myChart2.setOption(this.option2);
      myChart3.setOption(this.option3);
    },
    changeOtherLine(){
      var res1=[]
      var name1=[]
      var res2=[]
      var name2=[]
      Object.entries(this.visitRecordData[this.visitValue+'_dict']).forEach((item)=>{
        name1.push(item[0])
        res1.push(item[1])
      })
      Object.entries(this.visitRecordData1[this.visitValue1+'_dict']).forEach((item)=>{
        name2.push(item[0])
        res2.push(item[1])
      })
      this.option4.series[0].data = res1
      this.option4.xAxis.data = name1
      this.option5.series[0].data = res2
      this.option5.xAxis.data = name2
      let myChart4 = echarts.getInstanceByDom(document.getElementById('line1'))
      let myChart5 = echarts.getInstanceByDom(document.getElementById('line2'))
      if(myChart4 == null){
        myChart4 = echarts.init(document.getElementById("line1"));
      }
      if(myChart5 == null){
        myChart5 = echarts.init(document.getElementById("line2"));
      }
      myChart4.resize()
      myChart5.resize()
      myChart4.setOption(this.option4);
      myChart5.setOption(this.option5);
    },
    async postStatistics(year,month){
      let data = {}
      year ? data.year=year:''
      month ? data.month=month:''
      const res = await postStatistics(data)
      this.allData.user_day_res = res.create_result
      this.allData.user_day_disable = res.disable_result
      this.changeLine()
    },
    changeMargin(){
      this.changeLine()
      this.changePie();
      this.changeOtherLine()
    }
  },
  async mounted() {
    let _this=this
    // const res = await getStatistics();
    // const res1 = await visitRecord({type:0})
    // const res2 = await visitRecord({type:1})
    const bookList = await allBook()
    const book = [{label:'전체',value:''}]
    bookList.forEach((item)=>{
      book.push({label:item.title,value:item.id})
    })
    this.bookList = book
    Promise.all([getStatistics(),visitRecord({type:0}),visitRecord({type:1})]).then(res=>{
      this.allData = res[0]
      this.visitRecordData = res[1]
      this.visitRecordData1 = res[2]
      this.changeLine();
      this.changePie();
      this.changeOtherLine()
      window.onresize = function(){
        if(_this.$route.path==='/home'){
          _this.changeMargin()
        }
      };
    })
  },
};
</script>
<style lang="scss">
.el-select {
  .el-input__inner {
    height: 32px;
  }
  .el-input__icon {
    line-height: 32px;
  }
}
.el-input--suffix {
  .el-input__inner {
    height: 32px;
  }
  .el-input__icon {
    line-height: 32px;
  }
}
</style>